import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from '../config';
import Swal from 'sweetalert2';
import SidebarRFQ from '../POpage/SidebarRFQ';








 
  




const ClientAdd = () => {
  const [clients, setClients] = useState([]);
  const [clientForm, setClientForm] = useState({  client_name: '', client_country: '', client_phone_number: '', client_email: '', client_industry: '' });
  const [editMode, setEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const user = JSON.parse(localStorage.getItem("userdata"));


  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = () => {
    axios.get(`${BASE_URL}/api/client-get`)
      .then((res) => setClients(res.data))
      .catch((err) => console.error('Error fetching clients:', err));
  };

  const handleOpenModal = (client = null) => {
    setEditMode(!!client);
    setClientForm(client || { client_name: '', client_country: '', client_phone_number: '', client_email: '', client_industry: '' });
    window.$('#clientModal').modal('show');
  };

  const handleChange = (e) => {
    setClientForm({ ...clientForm, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const { id, client_name } = clientForm;
    if (!client_name.trim()) {
      Swal.fire('Error', 'Client name is required', 'error');
      return;
    }

    const url = `${BASE_URL}/api/${editMode ? `client-update/${id}` : 'client-add'}`;
    const method = editMode ? axios.put : axios.post;

    method(url, clientForm)
      .then(() => {
        Swal.fire('Success', `Client ${editMode ? 'updated' : 'added'} successfully!`, 'success');
        window.$('#clientModal').modal('hide');
        fetchClients();
      })
      .catch(() => Swal.fire('Error', `Failed to ${editMode ? 'update' : 'add'} client`, 'error'));
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "This client will be permanently deleted!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${BASE_URL}/api/client-delete/${id}`)
          .then(() => {
            Swal.fire('Deleted!', 'Client has been deleted.', 'success');
            fetchClients();
          })
          .catch(() => Swal.fire('Error', 'Failed to delete client', 'error'));
      }
    });
  };

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentData = clients.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(clients.length / itemsPerPage);

  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / 5) * 5;
    return new Array(Math.min(5, totalPages - start)).fill().map((_, i) => start + i + 1);
  };

  return (
    <div className='row'>
       <div className="custom-2-5">
      
                    <SidebarRFQ />
                    </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>CLIENT LIST</h5>
          <button className="btn btncolor" onClick={() => handleOpenModal()}>+ New Client</button>
        </div>

        <div className="table-responsive" style={{ background: '#fff' }}>
          <table className="table table-borderless custom-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Country</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Industry</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((client) => (
                <tr key={client.id}>
                  <td>{client.client_name || '-'}</td>
                  <td>{client.client_country || '-'}</td>
                  <td>{client.client_phone_number || '-'}</td>
                  <td>{client.client_email || '-'}</td>
                  <td>{client.client_industry || '-'}</td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => handleOpenModal(client)}>Edit</button>
                    {user.deletestatus === "1" && (
                    
                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(client.id)}>Delete</button>
                    )}
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="mt-3 d-flex justify-content-center">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>&laquo;</button>
                </li>
                {getPaginationGroup().map((pageNumber) => (
                  <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNumber)}>{pageNumber}</button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>&raquo;</button>
                </li>
              </ul>
            </nav>
          </div>
        )}

        {/* Bootstrap Modal */}
        <div className="modal fade" id="clientModal" tabIndex="-1" role="dialog" aria-labelledby="clientModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editMode ? 'Edit Client' : 'New Client'}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {['client_name', 'client_country', 'client_phone_number', 'client_email', 'client_industry'].map((field) => (
                  <div className="form-group" key={field}>
                    <label>{field.replace('client_', '').replace('_', ' ').toUpperCase()}</label>
                    <input
                      type="text"
                      className="form-control"
                      name={field}
                      value={clientForm[field]}
                      onChange={handleChange}
                      placeholder={`Enter ${field.replace('client_', '')}`}
                    />
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                  {editMode ? 'Update Client' : 'Add Client'}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* End Modal */}
      </div>
    </div>
  );
};

export default ClientAdd;


  
